<template>
  <el-dialog
    v-model="explainForm.explainVisible"
    width="400px"
    class="editDes_model"
    align-center
    :before-close="Cancel"
  >
    <template #header>
      <div class="header">
        <h4>{{ $t("slack.description") }}</h4>
      </div>
    </template>
    <el-input
      v-model="explainForm.textarea"
      :rows="4"
      type="textarea"
      maxlength="20"
      show-word-limit
    />
    <!-- <p class="hintText">说明此频道的用途。</p> -->
    <template #footer>
      <span class="dialog-footer">
        <el-button size="large" @click="Cancel">{{
          $t("slack.Cancel")
        }}</el-button>
        <el-button type="primary" size="large" @click="Confirm">{{
          $t("slack.Confirm")
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script setup>
import { HomeStore } from "../index";
import { storeToRefs } from "pinia";
import { reactive, watch, computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import * as $axios from "../api/index";
import { useDemoStore } from "@/pinia/index.js";
let explainForm = reactive({
  explainVisible: false, //编辑说明弹窗
  textarea: "",
});
const isEditdescribe = computed(() => HomeStore().setting.isEditdescribe);
const dialogueInfo = computed(() => HomeStore().setting.dialogueInfo);
watch(isEditdescribe, (val) => {
  explainForm.textarea = HomeStore().setting.dialogueInfo.description;
  explainForm.explainVisible = val;
});
function Cancel() {
  if (explainForm.textarea != dialogueInfo.value.description) {
    if (useDemoStore().lang == "en-us") {
      ElMessageBox.confirm(
        "Edited information not been saved yet. Are you sure to leave?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          HomeStore().setConfig("isEditdescribe", false);
        })
        .catch(() => {});
    }
    if (useDemoStore().lang == "zh-cn") {
      ElMessageBox.confirm("已编辑的信息尚未保存。你确定要离开吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          HomeStore().setConfig("isEditdescribe", false);
        })
        .catch(() => {});
    }
  } else {
    HomeStore().setConfig("isEditdescribe", false);
  }
}
function Confirm() {
  $axios
    .groupedit({
      token: HomeStore().token,
      group_id: dialogueInfo.value.group_id,
      description: explainForm.textarea,
    })
    .then(() => {
      ElMessage({
        type: "success",
        message: "success",
      });
      HomeStore().setting.dialogueInfo.description = explainForm.textarea;
    })
    .finally(() => {
      HomeStore().setConfig("isEditdescribe", false);
    });
}
</script>
<style lang="less">
.editDes_model {
  .header {
    h4 {
      font-size: 22px;
      font-weight: 900;
    }
  }
  .el-dialog__headerbtn {
    top: 6px !important;
  }
  .el-dialog__body {
    .hintText {
      color: rgba(var(--sk_foreground_max_solid, 97, 96, 97), 1);
      font-size: 13px;
      font-weight: 400;
      line-height: 1.38461538;
      margin-top: 4px;
    }
  }
}
</style>
